<template>
  <div class="data-deletion-page heavy-rain-gradient">
    <DataDeletionHeader />
    <DataDeletionContent />
    <DataDeletionRequestForm />
  </div>
</template>

<script>
import DataDeletionHeader from '../sections/cancellazione/DataDeletionHeader.vue'
import DataDeletionContent from '../sections/cancellazione/DataDeletionContent.vue'
import DataDeletionRequestForm from '../sections/cancellazione/DataDeletionRequestForm.vue'

export default {
  name: 'CancellazioneDati',
  components: {
    DataDeletionHeader,
    DataDeletionContent,
    DataDeletionRequestForm
  }
}
</script>

<style scoped>
.data-deletion-page {
  padding-top: 80px;
  min-height: 100vh;
}
</style>
